const API_BASE_URL = "https://api.dev.auxo.dk/public/v2/content";

export const FALLBACK_SERVICES = [
  {
    id: "06aee666-86fe-4c20-8164-6dbee895a406",
    slug: { da: "rengoering-privat" },
    title: "Rengøring privat",
    short_description: "Hos OP SERVICE udfører vi privat rengøring og andre daglige opgaver, så du får frihed til at gøre det, du har lyst til.",
    body_text: "<p>Hos OP SERVICE udfører vi privat rengøring og andre daglige opgaver, så du får frihed til at gøre det, du har lyst til. Vi udfører bl.a.</p><ul><li>Rengøring</li><li>Vinduespolering</li><li>Tøjvask og strygning</li><li>Indkøb og madlavning</li></ul><p>Vi gør vores ypperste for, at det er den samme medarbejder, der kommer i dit hjem hver gang. Vores servicemedarbejder medbringer miljøvenlige rengøringsmidler, rengøringsklude og moppe.</p>",
    primary_image: ["https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/rengoering-privat-stoevsugning-af-gulv-i-bolig.jpg"],
    secondary_images: [
      "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/rengoering-privat-rengoering-af-badevaerelse.jpg",
      "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/rengoering-privat-rengoering-af-spisebord-med-maskine.jpg",
      "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/rengoering-privat-aftoerring-og-rengoering-af-spisebord.jpg"
    ],
    icon: "fa-solid fa-house-chimney-window",
    gallery_slug: "rengoering-privat",
    related_services: "rengoering-erhverv,vinduespolering",
    contact_cta: "Få et uforpligtende tilbud på privatrengøring",
    sort_order: 1,
    meta_title: "Rengøring privat · OP RENGØRINGSSERVICE",
    meta_description: "Hos OP SERVICE udfører vi privat rengøring og andre daglige opgaver, så du får frihed til at gøre det, du har lyst til."
  },
  {
    id: "142971b3-9ea1-4812-aa36-9314d6c142cc",
    slug: { da: "rengoering-erhverv" },
    title: "Rengøring erhverv",
    short_description: "Vi tilbyder erhvervsrengøring hos virksomheder, restauranter, butikker, kontorer osv.",
    body_text: "<p>Vi tilbyder erhvervsrengøring hos virksomheder, restauranter, butikker, kontorer osv.</p><p>Vi udfører bl.a.</p><ul><li>Hovedrengøring</li><li>Engangsopgaver</li><li>Vinduespolering</li><li>Måtteservice</li><li>Pasning af indendørsplanter</li></ul><p>Hos OP SERVICE er vi fleksible og tilpasser os din virksomheds arbejdstider, så rengøringen foregår skånsomt og effektivt uden at forstyrre den daglige drift.</p>",
    primary_image: ["https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/rengoering-erhverv-gulvrengoering-i-lang-gang-01.jpg"],
    secondary_images: [
      "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/rengoering-erhverv-rengoering-af-kantine-og-spiseomraade-01.jpg",
      "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/rengoering-erhverv-indgangsparti-ved-erhvervsbygning-01.jpg",
      "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/rengoering-erhverv-stor-erhvervsbygning-og-udearealer-01.jpg",
      "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/rengoering-erhverv-erhvervsbygning-med-firmabil-01.jpg",
      "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/rengoering-erhverv-erhvervsbygning-med-gaardmiljoe-01.jpg"
    ],
    icon: "fa-solid fa-building",
    gallery_slug: "rengoering-erhverv",
    related_services: "maatteservice,vinduespolering",
    contact_cta: "Få et uforpligtende tilbud på erhvervsrengøring",
    sort_order: 2,
    meta_title: "Rengøring erhverv · OP RENGØRINGSSERVICE",
    meta_description: "Vi tilbyder erhvervsrengøring hos virksomheder, restauranter, butikker, kontorer osv."
  },
  {
    id: "ff288a50-a670-4338-b895-a98626536509",
    slug: { da: "snerydning" },
    title: "Snerydning",
    short_description: "Hos OP SERVICE tilbyder vi snerydning og glatførebekæmpelse hele vintersæsonen.",
    body_text: "<p>Hos OP SERVICE tilbyder vi snerydning og glatførebekæmpelse hele vintersæsonen.</p><p>Vi udfører arbejdet efter gældende lovgivning, og både privat- og erhvervskunder samt boligforeninger er blandt vores kunder. Ingen opgave er for stor eller for lille for os, og tryghed og tillid er nøgleord i alle vores kunderelationer.</p><p>Vores mandskab står klar til at rykke ud med professionelt udstyr, så dine fortove, p-pladser og indkørsler er sikre at færdes på.</p>",
    primary_image: ["https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/snerydning-1-1024x683-1.jpg"],
    secondary_images: ["https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/snefejning-2-1024x683-1.jpg"],
    icon: "fa-solid fa-snowflake",
    gallery_slug: "snerydning",
    related_services: "haveservice,tagrenderensning",
    contact_cta: "Få et uforpligtende tilbud på snerydning",
    sort_order: 3,
    meta_title: "Snerydning · OP RENGØRINGSSERVICE",
    meta_description: "Hos OP SERVICE tilbyder vi snerydning og glatførebekæmpelse hele vintersæsonen."
  },
  {
    id: "a10431b9-18a3-4f55-9dbf-52952d4dbd3a",
    slug: { da: "haveservice" },
    title: "Haveservice",
    short_description: "Hos OP SERVICE tilbyder vi anlæggelse og vedligeholdelse af haver og udenomsarealer både sommer og vinter.",
    body_text: "<p>Hos OP SERVICE tilbyder vi anlæggelse og vedligeholdelse af haver og udenomsarealer både sommer og vinter. Vores haveservice kunder er både private haveejere, foreninger og virksomheder.</p><p>Vi kan blandt andet hjælpe med:</p><ul><li>Græsslåning og hækklipning</li><li>Lugning og ukrudtsbekæmpelse</li><li>Beskæring af træer og buske</li><li>Forfaldende havearbejde og oprydning</li></ul>",
    primary_image: ["https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/haveservice-haekkeklipning-langs-hus.jpg"],
    secondary_images: [
      "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/haveservice-klipning-af-formklippede-haekke.jpg",
      "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/haveservice-graestrimning-ved-mark-og-skraaning.jpg"
    ],
    icon: "fa-solid fa-seedling",
    gallery_slug: "haveservice",
    related_services: "snerydning,tagrenderensning",
    contact_cta: "Få et uforpligtende tilbud på haveservice",
    sort_order: 4,
    meta_title: "Haveservice · OP RENGØRINGSSERVICE",
    meta_description: "Hos OP SERVICE tilbyder vi anlæggelse og vedligeholdelse af haver og udenomsarealer både sommer og vinter."
  },
  {
    id: "1a2a4f33-211e-4c81-b2d1-ef3d67ee7717",
    slug: { da: "vinduespolering" },
    title: "Vinduespolering",
    short_description: "Hos OP SERVICE pudser vi vinduer for både private og erhvervskunder.",
    body_text: "<p>Hos OP SERVICE pudser vi vinduer for både private og erhvervskunder. Vores kompetente personale imødekommer ethvert opdrag, og ingen opgave er for lille eller stor for os.</p><p>Vi pudser alle typer vinduer – fra parcelhuse til store erhvervsbygninger. Med vores professionelle udstyr sikrer vi altid et stribefrit og krystalklart resultat.</p>",
    primary_image: ["https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/vinduespolering-indvendig-pudsning-af-glasdoer.jpg"],
    secondary_images: [],
    icon: "fa-solid fa-sparkles",
    gallery_slug: "vinduespolering",
    related_services: "rengoering-privat,rengoering-erhverv",
    contact_cta: "Få et uforpligtende tilbud på vinduespolering",
    sort_order: 5,
    meta_title: "Vinduespolering · OP RENGØRINGSSERVICE",
    meta_description: "Hos OP SERVICE pudser vi vinduer for både private og erhvervskunder."
  },
  {
    id: "4a8a8b17-68bd-46ee-ab65-40eb0351b902",
    slug: { da: "maatteservice" },
    title: "Måtteservice",
    short_description: "Vi tilbyder en måtteløsning hvor vi efter en behovsvurdering udskifter dine måtter som aftalt.",
    body_text: "<p>Vi tilbyder en måtteløsning hvor vi efter en behovsvurdering, som du foretager i samråd med os, udskifter dine måtter som aftalt. Skiftefrekvens og måttetype kan variere og tilpasses dit behov.</p><p>Måtteservice er ideel til virksomheder, butikker og institutioner, der ønsker at holde indgangspartier rene og præsentable.</p>",
    primary_image: ["https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/maatteservice.jpg"],
    secondary_images: [],
    icon: "fa-solid fa-rug",
    gallery_slug: "maatteservice",
    related_services: "rengoering-erhverv",
    contact_cta: "Få et uforpligtende tilbud på måtteservice",
    sort_order: 6,
    meta_title: "Måtteservice · OP RENGØRINGSSERVICE",
    meta_description: "Vi tilbyder en måtteløsning hvor vi efter en behovsvurdering udskifter dine måtter som aftalt."
  },
  {
    id: "224b9517-91e0-43ad-80c5-6cb2a8acc6cf",
    slug: { da: "tagrenderensning" },
    title: "Tagrenderensning",
    short_description: "Vi udfører en grundig og effektiv tagrensning i form af sprøjtning af dit tag for mos og alger.",
    body_text: "<p>Vi udfører en grundig og effektiv tagrensning i form af sprøjtning af dit tag for mos og alger. Du får en fast pris udregnet på baggrund af tagets størrelse.</p><p>Samtidig tilbyder vi rensning af tagrender, så regnvand frit kan løbe væk og du undgår skader på husets facade og fundament.</p>",
    primary_image: ["https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/tagrenderensning-rensning-af-tagrende-med-teleskopudstyr.jpg"],
    secondary_images: [
      "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/andet-rensning-af-tegltag-med-teleskopudstyr.jpg",
      "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/andet-skumrensning-af-mur-og-terrasseomraade.jpg"
    ],
    icon: "fa-solid fa-house-chimney",
    gallery_slug: "tagrenderensning",
    related_services: "haveservice,snerydning",
    contact_cta: "Få et uforpligtende tilbud på tagrenderensning",
    sort_order: 7,
    meta_title: "Tagrenderensning · OP RENGØRINGSSERVICE",
    meta_description: "Vi udfører en grundig og effektiv tagrensning i form af sprøjtning af dit tag for mos og alger."
  }
];

export async function fetchCmsServices() {
  try {
    const res = await fetch(`${API_BASE_URL}/services?sort=sort_order&order=asc`);
    if (!res.ok) throw new Error(`HTTP error ${res.status}`);
    const data = await res.json();
    if (data.items && data.items.length > 0) {
      return data.items;
    }
  } catch (err) {
    console.warn("CMS fetchServices failed, returning fallback:", err);
  }
  return FALLBACK_SERVICES;
}

export async function fetchCmsServiceBySlug(slug) {
  try {
    const res = await fetch(`${API_BASE_URL}/services?slug.da=${slug}`);
    if (res.ok) {
      const data = await res.json();
      if (data.items && data.items.length > 0) {
        return data.items[0];
      }
    }
  } catch (err) {
    console.warn("CMS fetchServiceBySlug error:", err);
  }
  return FALLBACK_SERVICES.find((s) => (s.slug.da || s.slug) === slug) || null;
}

export async function fetchCmsPages() {
  try {
    const res = await fetch(`${API_BASE_URL}/pages?sort=sort_order&order=asc`);
    if (!res.ok) throw new Error(`HTTP error ${res.status}`);
    const data = await res.json();
    return data.items || [];
  } catch (err) {
    console.warn("CMS fetchPages failed:", err);
    return [];
  }
}

export async function fetchCmsPageBySlug(slug) {
  try {
    const res = await fetch(`${API_BASE_URL}/pages?slug.da=${slug}`);
    if (res.ok) {
      const data = await res.json();
      if (data.items && data.items.length > 0) {
        return data.items[0];
      }
    }
  } catch (err) {
    console.warn("CMS fetchPageBySlug error:", err);
  }
  return null;
}

export async function fetchCmsGalleryBySlug(slug) {
  try {
    const res = await fetch(`${API_BASE_URL}/galleries?slug.da=${slug}`);
    if (res.ok) {
      const data = await res.json();
      if (data.items && data.items.length > 0) {
        return data.items[0];
      }
    }
    // Also try with 'galleri-' prefix if original slug passed
    if (!slug.startsWith("galleri-")) {
      const resAlt = await fetch(`${API_BASE_URL}/galleries?slug.da=galleri-${slug}`);
      if (resAlt.ok) {
        const dataAlt = await resAlt.json();
        if (dataAlt.items && dataAlt.items.length > 0) {
          return dataAlt.items[0];
        }
      }
    }
  } catch (err) {
    console.warn("CMS fetchGalleryBySlug error:", err);
  }
  return null;
}
